import React from 'react';
import SubServices from '../../components/AdminNext/SubServices';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Sub-services — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <SubServices />
      </HeadLessLayout>
    )
  };
}

export default action;
